import React from 'react';
import { observer } from 'mobx-react';

import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DatePicker from 'react-datepicker';

const ScheduleDate = observer(class ScheduleDate extends React.Component {
  constructor() {
    super();
    this.handleExamChange = this.handleExamChange.bind(this);
    this.changeTime = this.changeTime.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.state = {
      examDate: null,
      selectedDate: null,
      renderCal: true
    }
  }

  // componentWillUpdate(nextProps, nextState) {
  //   /*
  //     This is really hacky, but there’s a bug with Datepicker
  //     and it was the only fix documented. Essentially, there
  //     is a problem where the time zone isn’t necessarily taken
  //     into account for the maxDate which caused some students
  //     to be able to select dates that they shouldn’t have been
  //     able to choose. Providing a selected date fixes the issue
  //     for some reason. So this will select the end date of the
  //     exam, then clear the selection.
  //
  //     Also, we don’t want this to run until the Datepicker is
  //     actually in view (i.e. step 2 of scheduling), otherwise
  //     the fix doesn’t work.
  //   */
  //   const _this = this;
  //   const { selectedDate } = nextState;
  //   const { step } = nextProps;
  //   const { examConfiguration } = this.props.store.ExamStore.examSession;
  //   const { userTimezone } = this.props.store.SessionStore;
  //
  //   // Make sure we’re on step 2 and check that
  //   // no date has already been set (to avoid a loop)
  //   if(this.props.step === 1 && step === 2 && !selectedDate) {
  //     this.setState({
  //       renderCal: true,
  //       selectedDate: moment(examConfiguration.examCloseDate).subtract(30, 'minutes').subtract(examConfiguration.duration, 'minutes').tz(userTimezone)
  //     }, function(){
  //       _this.setState({
  //         selectedDate: moment(examConfiguration.examCloseDate).tz(userTimezone).add(1, 'days')
  //       });
  //
  //       // Check if there’s a month back button
  //       // and click it if there is one
  //       const monthBack = document.querySelector('.schedule-date-form .react-datepicker__navigation--previous');
  //
  //       if(monthBack) {
  //         monthBack.click();
  //       }
  //     });
  //   }
  // }

  handleExamChange(date) {
    const _this = this;
    const { examConfiguration } = this.props.store.ExamStore.examSession;

    this.setState({
      examDate: date,
      selectedDate: date
    }, function(){
      _this.handleSubmit(examConfiguration.examOpenDate, examConfiguration.examCloseDate);
    });
  }

  changeTime() {
    this.props.store.ScheduleStore.onlineTimeRange = this.time.value;
  }

  round(date, duration, method) {
    return moment(Math[method]((+date) / (+duration)) * (+duration));
  }

  handleSubmit(examOpenDate, examCloseDate) {
    const { combined, hybrid, proctorGroupSid, store } = this.props;
    const { ProctorStore, SessionStore, ScheduleStore } = store;
    const { userTimezone } = SessionStore;

    // Make sure the date is after the exam start date
    let chosenDate = moment(this.state.examDate);
    let minDate = moment(examOpenDate).tz(userTimezone);
    const maxDate = moment(examCloseDate).tz(userTimezone);
    const timeDiff = moment.duration(chosenDate.diff(minDate)).asHours();
    const closeDiff = moment.duration(chosenDate.diff(maxDate)).asHours();

    // Round date to the nearest 15 minutes
    minDate = this.round(minDate, moment.duration(15, 'minutes'), 'ceil');

    // If the chosen date is before the exam start date, use the exam start date.
    // This is necessary when the exam starts at a time later than 12:00 midnight
    // since the datepicker defaults to 12:00 for dates.
    // Also add 1 second because the API won’t accept the exact same time as the
    // exam open date.
    if(timeDiff <= 0) {
      chosenDate = moment(minDate).add(1, 's');
    }

    // If the chosen date is equal to the exam end date, remove one second because
    // the API won’t accept the exact same time as the close date.
    if(closeDiff >= 0) {
      chosenDate = moment(maxDate).subtract(1, 's');
    }

    // Set the chosen date in the store and re-run the get availability endpoint
    const dateString = moment(chosenDate).format('YYYY-MM-DD HH:mm');
    const timezoneString = moment(chosenDate).tz(userTimezone).format('Z');
    let newDate = moment.utc(`${dateString} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z')
                              .tz(userTimezone)
                              .toISOString();

    ScheduleStore.onlineDate = newDate;

    if(hybrid) {
      const query = {
        combined,
        //tiered: true,
        proctorGroupSids: proctorGroupSid
      }

      ScheduleStore.getOnlineAvailability(this.props.examSid, this.props.sessionSid, query, this.props.reschedule);
    } else if(ProctorStore.proctors[0].location.schedulingModule !== 'b-virtual') {
      ScheduleStore.getOnlineAvailability(this.props.examSid, this.props.sessionSid);
    } else {
      ScheduleStore.getBVAvailability(this.props.examSid, this.props.sessionSid);
    }

    // Reset the form
    // this.setState({
    //   examDate: null
    // });
    //
    // document.querySelector('.schedule-date-form').classList.remove('submitted');
  }

  render() {
    const { translation } = this.props;
    const { examConfiguration } = this.props.store.ExamStore.examSession;
    const { userTimezone } = this.props.store.SessionStore;
    let minDate = null;
    let maxDate = moment(examConfiguration.examCloseDate).subtract(30, 'minutes').subtract(examConfiguration.duration, 'minutes').tz(userTimezone);

    const now = moment(this.props.store.SessionStore.currentTime);
    minDate = moment(examConfiguration.examOpenDate);
    const timeDiff = moment.duration(minDate.diff(now)).asHours();

    if(timeDiff < 0) {
      minDate = now;
    }

    // Make sure the maxDate isn’t before the minDate
    const maxDiff = moment.duration(maxDate.diff(minDate)).asMinutes();

    if(maxDiff < 0) {
      maxDate = moment(minDate).add(1, 'minutes').tz(userTimezone);
    }

    return(
      <form
        className="schedule-date-form"
        onSubmit={(e) => checkValidity(e, () => {this.handleSubmit(examConfiguration.examOpenDate, examConfiguration.examCloseDate)})}
        noValidate
      >
        <ul className="fields">
          <li>
            <label className="lbl-required meta">{translation.exam_date}</label>

            {this.state.renderCal &&
              <DatePicker
                inline
                calendarClassName="react-datepicker--inline"
                selected={this.state.examDate ? moment(this.state.examDate) : null}
                onChange={this.handleExamChange}
                minDate={minDate}
                maxDate={maxDate}
                placeholderText="mm/dd/yyyy"
                required
                autoComplete="off"
              />
            }
          </li>
          <li>
            <label className="meta" htmlFor="schedule-time">{translation.time}</label>

            <label className="select">
              <select
                id="schedule-time"
                ref={(input) => this.time = input}
                onChange={this.changeTime}
              >
                <option value="">{translation.any}</option>
                <option value="morning">{translation.morning}</option>
                <option value="afternoon">{translation.afternoon}</option>
                <option value="evening">{translation.evening}</option>
              </select>
            </label>
          </li>
        </ul>

        {/* <button
          className="btn"
          type="submit"
        >
          <icons.iconCalendar />
          {translation.button}
        </button> */}
      </form>
    );
  }
})

export default translate('ScheduleDate')(ScheduleDate);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ScheduleDate.js